const TypeCollaboratorEnum = {
  NORMAL: 0,
  PRINCIPAL: 1,
}

export default TypeCollaboratorEnum
